<template>
  <el-main class="main-con el-main">

    <el-row :gutter="10" class="grid-content">
      <el-col :span="12"><div class="bg-purple">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>每日统计指标值</span>
              <ul class="day-zhibiao of">
                <li>{{reportingStatisticsValues.FinancingCountToday||0}}</li>
                <li>{{reportingStatisticsValues.NewCustomer||0}}</li>
                <li>{{reportingStatisticsValues.PaymentCountToday||0}}</li>
                <li>{{reportingStatisticsValues.RepaymentCountToday||0}}</li>
              </ul>
              <ul class="day-zhibiao-text of">
                <li>新客户数</li>
                <li>提款笔数</li>
                <li>放款笔数</li>
                <li>还款笔数</li>
              </ul>
            </div>
          </el-card>
      </div></el-col>
      <el-col :span="12"><div class="bg-purple">
          <el-card class="box-card"  shadow="never">
            <div slot="header" class="clearfix">
              <span>基础设置</span>
            </div>
            <ul class="pannel_02">
              <li class="first">金融机构功能权限</li>
              <li class="second tc"><router-link :to="{name:'ConfigRoleListView'}" class="color-blue">已配置</router-link></li>
              <li class="tc third">用户数</li>
              <li class="fouth tc"><span class="num">{{reportingStatisticsValues.MerchantUserCount||0}}</span><span>个</span></li>
              <li class="fifth tr"><router-link :to="{name:'ConfigUserListView'}" class="color-blue">进入维护</router-link></li>
            </ul>
            <ul class="pannel_02">
              <li class="first">金融机构账户配置</li>
              <li class="second tc"><router-link :to="{name:'ConfigUserListView'}" class="color-blue">已配置</router-link></li>
              <li class="tc third">客户数</li>
              <li class="fouth tc"><span class="num">{{reportingStatisticsValues.ActiveCustomer||0}}</span><span>个</span></li>
              <li class="fifth tr"><a href="" class="color-blue"></a></li>
            </ul>
            <ul class="pannel_02">
              <li class="first">参数设置</li>
              <li class="second tc"><router-link :to="{name:'ConfigSettingView'}" class="color-blue">已配置</router-link></li>
              <li class="tc third">产品个数</li>
              <li class="fouth tc"><span class="num">{{reportingStatisticsValues.ActiveProduct||0}}</span><span>个</span></li>
              <li class="fifth tr"><router-link :to="{name:'ServiceAdminProductEditView'}" class="color-blue">马上去加</router-link></li>
            </ul>

          </el-card>
      </div></el-col>
    </el-row>

    <el-row :gutter="10" class="grid-content">
      <el-col :span="9"><div class="bg-purple">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>待办事项</span>
            </div>
            <div class="">
              <ul class="fl pannel" style="width:49%">
                <li>待审核客户</li>
                <li><span class="num"><router-link :to="{name:'CustomerApplyingCustomerList'}">{{reportingStatisticsValues.ApplyingCustomer||0}}</router-link></span><span>个</span></li>
              </ul>
              <ul class="fr pannel" style="width:49%;">
                <li>待审核放款<span><router-link :to="{name:'FinancePaymentPendingPayListView'}">{{reportingStatisticsValues.ReadyFinancing||0}}</router-link></span><span>笔</span></li>
              </ul>
              <ul class="fl pannel" style="width:49%">
                <li>待审核提款</li>
                <li><span><router-link :to="{name:'ServiceAdminFinancingApplyingListView'}">{{reportingStatisticsValues.ApplyingFinancing||0}}</router-link></span><span>笔</span></li>
              </ul>
              <ul class="fr pannel" style="width:49%;">
                <li>待退还款<br/><span class="num0">{{reportingStatisticsValues.ApplyingRefund||0}}</span><span>笔</span></li>
              </ul>
            </div>


          </el-card>
      </div></el-col>
      <el-col :span="15"><div class="bg-purple">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>最近常用功能</span>
            </div>
            <ul class="quickmenulist">
              <li><router-link :to="{name:'ConfigUserListView'}">用户管理</router-link></li>
              <li><router-link :to="{name:'ConfigRoleListView'}">角色权限</router-link></li>
              <li><router-link :to="{name:'ConfigDepartmentView'}">部门管理</router-link></li>
              <li><router-link :to="{name:'CustomerCustomerListView'}">客户管理</router-link></li>
              <li><router-link :to="{name:'ServiceAdminProductListView'}">产品管理</router-link></li>
              <li><router-link :to="{name:'ServiceAdminBankAccountView'}">账户配置</router-link></li>
            </ul>
          </el-card>
      </div></el-col>
    </el-row>

    <el-row class="grid-content">
      <el-col :span="24"><div class="bg-purple">
          <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
              <span>业务统计量(最近30天)</span>
            </div>
            <div>
              <ve-line :data="lineChartData" :settings="lineChartSetting" ref="last30DaysCountChart"></ve-line>
            </div>
          </el-card>
      </div></el-col>
    </el-row>

  </el-main>
</template>

<script>
  import xhr from "../../../utils/xhr";
  import moment from 'moment'

  export default {
    data() {
      return {
        options: [
          'MerchantUserCount',
          'ActiveCustomer',
          'ApplyingCustomer',
          'ActiveProduct',
          'ApplyingFinancing',
          'ReadyFinancing',
          'ApplyingCustomer',
          'FinancingCountToday',
          'PaymentCountToday',
          'RepaymentCountToday',
          'NewCustomer'
        ],
        reportingStatisticsValues: {},
        lineChartSetting: {
          xAxisType: 'time'
        },
        lineChartData: {
          columns: ['日期', '还款笔数', '提款笔数', '放款笔数'],
          rows: [
            { '日期': '2018-01-01', '还款笔数': 1, '提款笔数': 0, '放款笔数': 4 },
          ]
        },
      }
    },
    mounted() {
      this.getReportingStatisticsValues(this.options.join(','))
      this.getReportingRepaymentPaymentFinancingCountLast30Days()
    },
    methods: {
      getReportingStatisticsValues: function (options) {
        xhr.getReportingStatistics(
          {
            options
          },
          res => {
            this.reportingStatisticsValues = res.data.data
          }
        )
      },
      getReportingRepaymentPaymentFinancingCountLast30Days: function () {
        xhr.getReportingRepaymentPaymentFinancingCountLast30Days(
          {

          },
          res=>{
            try {
                let
                [
                  RepaymentCountLast30Days,
                  PaymentCountLast30Days,
                  FinancingCountLast30Days
                ] = Object.keys(res.data).map(key=>res.data[key])

              const lastThirtyDays = [...new Array(30)].map((i, idx) => moment().startOf("day").subtract(idx, "days").format('YYYY-MM-DD')).reverse();

                this.lineChartData.rows = lastThirtyDays.map(date=>{
                  let RepaymentObj = RepaymentCountLast30Days.data.filter(item=>item.re__payDate==date).shift()
                  let PaymentObj = PaymentCountLast30Days.data.filter(item=>item.pay__payDate==date).shift()
                  let FinancingObj = FinancingCountLast30Days.data.filter(item=>item.fi__transactionDate==date).shift()
                  return {
                    '日期' : date,
                    '还款笔数' : typeof RepaymentObj == 'object' ? RepaymentObj.re__counts||0 : 0,
                    '提款笔数' : typeof PaymentObj == 'object' ? PaymentObj.pay__counts||0 : 0,
                    '放款笔数' : typeof FinancingObj == 'object' ? FinancingObj.fi__counts||0 : 0,
                  }
                })

            }catch (e) {
              console.log(e)
            }
          }
        )
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigIndex.vue